import { Component, Input } from '@angular/core';

@Component({
	selector: 'setting-section-description',
	template: require('./setting-section-description.html'),
	styles: [require('./setting-section-description.scss')]
})
export class SettingSectionDescriptionComponent {
	@Input() text: string;

	constructor() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/settings/common/setting-section-description/setting-section-description.ts